import React from 'react';
import { Avatar, Box, Chip, IconButton, Typography } from '@mui/material';
import { ChevronRight } from '@mui/icons-material';
import colors from '../../assets/theme/colors';
import { getRoleDisplay } from '../../constants/roles';

const CareTeamContextCard = ({
  child,
  role,
  onOpenDetails,
}) => {
  if (!child) return null;

  const roleDisplay = getRoleDisplay(role);

  return (
    <Box
      onClick={onOpenDetails}
      role={onOpenDetails ? 'button' : undefined}
      sx={{
        mx: 2,
        mt: 1.5,
        mb: 1,
        px: 1.5,
        py: 1.25,
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        borderRadius: 4,
        border: '1px solid',
        borderColor: 'rgba(226, 232, 240, 0.9)',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.06)',
        cursor: onOpenDetails ? 'pointer' : 'default',
      }}
    >
      <Avatar src={child.photoURL} sx={{ width: 44, height: 44 }}>
        {child.name?.charAt(0) || 'C'}
      </Avatar>

      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: '1.05rem',
            fontWeight: 800,
            color: colors.landing.heroText,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {child.name}
        </Typography>
        <Chip
          size="small"
          label={roleDisplay.plainLabel}
          sx={{
            mt: 0.7,
            height: 28,
            fontSize: '0.82rem',
            fontWeight: 700,
            color: roleDisplay.color,
            bgcolor: `${roleDisplay.color}16`,
            border: `1px solid ${roleDisplay.color}30`,
            borderRadius: 999,
          }}
        />
      </Box>

      {onOpenDetails ? (
        <IconButton
          aria-label="Open child and care circle details"
          sx={{ color: colors.landing.heroText }}
        >
          <ChevronRight />
        </IconButton>
      ) : null}
    </Box>
  );
};

export default CareTeamContextCard;
